import AppConfiguration from './AppConfiguration';
export default AppConfiguration;